import { render, staticRenderFns } from "./RegAddOnListItem.vue?vue&type=template&id=4608b203&scoped=true&"
import script from "./RegAddOnListItem.vue?vue&type=script&lang=js&"
export * from "./RegAddOnListItem.vue?vue&type=script&lang=js&"
import style0 from "./RegAddOnListItem.vue?vue&type=style&index=0&id=4608b203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4608b203",
  null
  
)

export default component.exports